import React, { Component } from "react";
import * as PIXI from "pixi.js";
import UIManager from "../../core/components/ui/UiBuilder";
import { withPixiApp } from "@inlet/react-pixi";
import { GJIStore } from "../../gamestore/IStore";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import withMainSettingPanelPortraitComponentConfiguration from "./configuration/withMainSettingPanelPortraitComponentConfiguration";
import { ConsoleView, isMobile } from "react-device-detect";
import { configGame, constant } from "../../data/config";
//import { Scrollbox } from 'pixi-scrollbox'
import { TIMER } from "../../core/utills";
import { actions as autoplayKeyboardListenerAction } from "../../gamereducer/autoplayKeyboardListenerReducer";
import { actions as mainSettingPanelActions } from "../../gamereducer/mainSettingPanelMobReducer";
import { actions as aplicationActions } from "../../core/reducers/applicationStateReducer";
import { actions as layoutsActions } from "../../core/reducers/layoutsStateReducer";
import { actions as behaviourAction } from "../../gamereducer/behaviourReducer";
import { actions as asyncActions } from "../../core/reducers/asyncServerResponseReducer";
import { actions as soundActions } from "../../core/reducers/soundReducer";
import { actions as gameLevelSoundActions } from "../../gamereducer/soundGameLevelReducer";
import GameGuideComponent from "../gameGuideComponent/gameGuideComponent";
import { actions as reelGridActions } from "../../core/reducers/reelgridStateReducer";
import { actions as gridsActions } from "../../core/reducers/gridStateReducer";
interface IStore {
    [x: string]: any;
}
interface IProps {
    [x: string]: any;
}

interface IState {

}

interface IStateToProps {
}

interface IDispatchToProps {
}

class MainSettingPanelPortraitComponent extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected displayUI: any;
    protected mainSettingPanelPortraitComponent: any;
    protected gameAutoplayComponentContainer: any;
    protected scope: any;
    protected ui_mode: string;
    protected gameAutoplayComponentList: Array<any>
    private singlewinlimit: any;
    private testLineX1: number = 325;
    private testLineX2: number = 693;
    private testLineX3: number = 785;

    private counter: number = 0;

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.mainSettingPanelPortraitComponent = React.createRef();
        this.gameAutoplayComponentContainer = React.createRef();
        this.state = {
            uiElements: [],
            lang: "en"
        }

        if (isMobile) {
            this.ui_mode = "mobile"
        } else {
            this.ui_mode = "desktop"
        }
        //reel,row
        this.gameAutoplayComponentList = []
        this.displayUI = this.props.data.COMPONENTS[0].child.filter(this.checkUiMode.bind(this));
    }

    checkUiMode(uimodeobj: any) {
        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both"
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    bindUI() {
        this.addScrollBar();

    }

    addScrollBar() {
        let gameAutoplayContent: any = UIManager.getRef("gameAutoplayContent")
        let gameAutoplayScrollComponent: any = UIManager.getRef("gameAutoplayScrollComponent")

        const Scrollbox = require('pixi-scrollbox').Scrollbox
        const scrollbox = new Scrollbox({ boxWidth: 800, boxHeight: 700 })

        scrollbox.x = 550;
        scrollbox.y = 200;

        gameAutoplayScrollComponent && gameAutoplayScrollComponent.addChild(scrollbox)
        // add a sprite to the scrollbox's content
        const sprite = scrollbox.content.addChild(new PIXI.Sprite(PIXI.Texture.WHITE))
        sprite.width = 800
        sprite.height = 700
        sprite.tint = 0x131313
        scrollbox.content.addChild(gameAutoplayContent);
        // force an update of the scrollbox's calculations after updating the children
        // add the viewport to the stage
        scrollbox.update()
    }

    radioController(currentToggleState: any, nextToggleState: any) {
        UIManager.getRef(currentToggleState) && (UIManager.getRef(currentToggleState).visible = false);
        UIManager.getRef(currentToggleState) && (UIManager.getRef(nextToggleState).visible = true);
    }

    layoutChange(currentLayout: string) {
        //  this.displayUI.map((data: any) => {
        //      if (data.layout === true) {
        //          this.props.setApplicationLayoutObject(data.name);
        //      }
        //  }
        //  )

        // this.setVisibilityAccordingToLayout();
    }

    setVisibilityAccordingToLayout(nextProps: any) {
        if (nextProps.showSettingPanelForMobile) {
            if (isMobile && window.innerWidth < window.innerHeight) {
                UIManager.getRef("mainSettingPanelPortraitComponent").visible = true;
            }
            else if (isMobile && window.innerWidth > window.innerHeight) {
                if (UIManager.getRef("mainSettingPanelPortraitComponent")) {
                    UIManager.getRef("mainSettingPanelPortraitComponent").visible = false;
                }


            }
        }
    }
    changeButtonsState(clickedButtonWhiteState: any, clickedButtonYellowState: any, clickButonScreenText: any) {
        this.displayUI.map((data: any) => {
            {
                data.child && data.child.map((innerData: any) => {
                    let buttonName = innerData.name;
                    if (buttonName.startsWith("btn_")) {
                        if (buttonName.endsWith("white")) {
                            UIManager.getRef(buttonName).visible = true;
                        }

                        else {
                            UIManager.getRef(buttonName).visible = false;
                        }

                        UIManager.getRef(clickedButtonYellowState).visible = true;
                        UIManager.getRef(clickButonScreenText).visible = true;
                        // if (clickButonScreenText == 'btn_Portraitsetting_text1_yellow') {
                        //
                        //     UIManager.getRef("btn_Portraitsetting_text2_white").visible = true;
                        //
                        //     UIManager.getRef("yellowLine").x = this.testLineX1;
                        // }
                        // else {
                        //     UIManager.getRef("btn_setting_text2_white").visible = false;
                        //     UIManager.getRef("btn_setting_text1_white").visible = false;
                        //     UIManager.getRef("yellowLine").x = this.testLineX2;
                        // }

                    }
                })
            }
        }
        )
    }

    handleReelSpinType(value: any) {
        if (Number(configGame["SPIN_TYPE"]) === 0) {
            /* const {
                startSpin
            } = this.props;
            startSpin(); */
        } else if (Number(configGame["SPIN_TYPE"]) === 2) {
            const {
                setReelGridTurboMode
            } = this.props;
            setReelGridTurboMode(value);
        } else {
            const {
                setGridTurboMode
            } = this.props;
            setGridTurboMode(value);
        }
    }
    showContent(containerName: any) {
        UIManager.getRef("gameGuideComponentPortrait").visible = false;
        UIManager.getRef("gameGeneralComponentPortrait").visible = false;
        // UIManager.getRef("gameAutoplayComponentPortrait").visible = false;
        UIManager.getRef("mobilePaytableContainerPortrait").visible = false;


        if (containerName != "") { UIManager.getRef(containerName).visible = true; }
        if (isMobile && window.innerWidth < window.innerHeight && containerName == "gameGeneralComponentPortrait") {

            if (!this.props.turboToggle) {
                UIManager.getRef("turboSpinRadioButtonOnPortrait") && (UIManager.getRef("turboSpinRadioButtonOnPortrait").visible = true);
                UIManager.getRef("turboSpinRadioButtonOffPortrait") && (UIManager.getRef("turboSpinRadioButtonOffPortrait").visible = false);

            }
            else {
                UIManager.getRef("turboSpinRadioButtonOffPortrait") && (UIManager.getRef("turboSpinRadioButtonOffPortrait").visible = true);
                UIManager.getRef("turboSpinRadioButtonOnPortrait") && (UIManager.getRef("turboSpinRadioButtonOnPortrait").visible = false);
            }




        }
    }
    handleEvent = (e: any) => {
        switch (e.target.name) {

            case "btn_Portraitguide_white":
                this.changeButtonsState("btn_Portraitguide_white", "btn_Portraitguide_yellow", "btn_Portraitguide_text");
                this.showContent("gameGuideComponentPortrait");
                this.props.showBetHistory(false);
                this.props.showSettingPanelContainerForMobile(true, 'guide');
                return;
            case "btn_Portraitpaytable_white":
                this.props.showBetHistory(false);
                this.changeButtonsState("btn_Portraitpaytable_white", "btn_Portraitpaytable_yellow", "btn_Portraitpaytable_text");
                this.showContent("mobilePaytableContainerPortrait");
                this.props.showSettingPanelContainerForMobile(true, 'paytable');
                return;
            case "btn_Portraithistory_white":
                this.changeButtonsState("btn_Portraithistory_white", "btn_Portraithistory_yellow", "btn_Portraithistory_text");
                this.showContent("");
                this.props.showBetHistory(true);
                this.props.getApplicationHistoryResponse();
                this.props.showSettingPanelContainerForMobile(true, 'history');

                return;
            case "btn_Portraitsetting_white":
                this.changeButtonsState("btn_Portraitsetting_white", "btn_Portraitsetting_yellow", "btn_PortraitGeneral_text");
                this.showContent("gameGeneralComponentPortrait");
                this.props.showBetHistory(false);
                this.props.showSettingPanelContainerForMobile(true, 'general');

                return;

            case "settingPanelCloseButton_portrait":
                this.props.showSettingPanelContainerForMobile(false, '');
                this.showContent("gameGeneralComponentPortrait");
                this.props.showBetHistory(false);
                return;

            //   case "gameSettingsBtnMobile":
            //       this.showGeneral();
            //
            //
            //       this.showContent("gameGeneralComponent");
            //
            //       return;
            //   case "autoplayBtnMobile":
            //       this.showAutoplay();
            //
            //     this.showContent("gameAutoplayComponent");
            //       // this.showContent();
            //       return;
            // case "btn_setting_yellow":
            //
            //     UIManager.getRef(e.target.name).visible = false;
            //     UIManager.getRef("btn_setting_white").visible = true;
            //      return;
            default:
                return 'No buttons';
        }
    }
    showGeneral() {
        UIManager.getRef("btn_Portraitsetting_text1_white").visible = false;
        UIManager.getRef("btn_Portraitsetting_text1_yellow").visible = true;
        UIManager.getRef("btn_Portraitsetting_text2_white").visible = true;
        UIManager.getRef("btn_Portraitsetting_text2_yellow").visible = false;
        //  UIManager.getRef("yellowLine").x = this.testLineX1;
    }


    showAutoplay() {



        UIManager.getRef("btn_setting_text1_white").visible = true;
        UIManager.getRef("btn_setting_text1_yellow").visible = false;
        // UIManager.getRef("btn_setting_text2_white").visible = false;
        // UIManager.getRef("btn_setting_text2_yellow").visible = true;
        // UIManager.getRef("yellowLine").x = this.testLineX3;
    }
    componentDidMount() {
        this.bindUI();

        if (this.props.turboToggle) {
            if ((window as any).GAME_INFO.jurisdiction == "uk" || (window as any).GAME_INFO.jurisdiction == "es"
                || (window as any).GAME_INFO.jurisdiction == "de"
                || (window as any).GAME_INFO.jurisdiction == "gr"
                || (window as any).GAME_INFO.jurisdiction == "se") {
                this.handleReelSpinType(false);
            }
            else {
                this.handleReelSpinType(true);
            }
        }
        this.addListenersToTextFields();
    }

    addListenersToTextFields() {
        this.singlewinlimit = UIManager.getRef("singlewinlimit_disable");
        this.singlewinlimit.interactive = true;
        this.singlewinlimit.click = (event: any) => {
            //alert("hehe not again")
            //this.props.setAutoplayKeyboardListenerActive(true)

        }
    }

    selectButtonAndContent() {
        if (this.props.showSettingPanelForMobile && (isMobile && window.innerWidth < window.innerHeight)) {
            UIManager.getRef("mainSettingPanelPortraitComponent").visible = true;
            if (this.props.openScreen == "paytable") {
                this.changeButtonsState("btn_Portraitpaytable_white", "btn_Portraitpaytable_yellow", "btn_Portraitpaytable_text");
                this.showContent("mobilePaytableContainerPortrait");
            }
            else if (this.props.openScreen == "guide") {
                this.changeButtonsState("btn_Portraitguide_white", "btn_Portraitguide_yellow", "btn_Portraitguide_text");
                this.showContent("gameGuideComponentPortrait");
            }
            else if (this.props.openScreen == "history") {
                this.changeButtonsState("btn_Portraithistory_white", "btn_Portraithistory_yellow", "btn_Portraithistory_text");
                this.showContent("");
                this.props.showBetHistory(true);
                this.props.getApplicationHistoryResponse();
            }

            else if (this.props.openScreen == "general") {
                this.changeButtonsState("btn_Portraitsetting_white", "btn_Portraitsetting_yellow", "btn_PortraitGeneral_text");
                this.showContent("gameGeneralComponentPortrait");
                this.props.showBetHistory(false);
            }
            this.handleSoundRadioButtons(this.props.allSoundSFXStop);
            this.handleBgMusicRadioButtons(this.props.allSoundBGMStop);

        }

        if (this.props.homeButton) {
            UIManager.getRef("homeButton_portrait").visible = true;
            UIManager.getRef("homeButton_portrait").addListener('touchend', (evt: MouseEvent): void => {
                this.homeButtonClicked();
            })
        }

    }
    componentDidUpdate() {
        this.selectButtonAndContent();
        /*      if (this.props.showSettingPanelForMobile && (isMobile && window.innerWidth > window.innerHeight)) {
                 UIManager.getRef("mainSettingPanelComponent").visible = true;
     
                 if (this.props.openScreen == "paytable") {
                     this.changeButtonsState("btn_paytable_white", "btn_paytable_yellow", "btn_paytable_text");
                     this.showContent("mobilePaytableContainer");
                 }
                 else if (this.props.openScreen == "guide") {
                     this.changeButtonsState("btn_guide_white", "btn_guide_yellow", "btn_guide_text");
                     this.showContent("gameGuideComponent");
                 }
                 else if (this.props.openScreen == "history") {
                     this.changeButtonsState("btn_history_white", "btn_history_yellow", "btn_history_text");
                     this.showContent("");
                     this.props.showBetHistory(true);
                     this.props.getApplicationHistoryResponse();
                 }
     
                 else if (this.props.openScreen == "general") {
                     this.changeButtonsState("btn_setting_white", "btn_setting_yellow", "btn_setting_text1_yellow");
                     this.showContent("gameGeneralComponent");
                     this.props.showBetHistory(false);
                 }
     
             }
      */

    }



    homeButtonClicked() {
        //game-close wrapper message
        (window as any).CLIENT_WRAPPER_INIT.send("game-close");
        if ((window as any).CLIENT_WRAPPER_INIT.doLobbyURLNavigate) {
            (window as any).top.location.href = (window as any).GAME_INFO.lobbyurl;
        }
    }
    handleSoundRadioButtons(isSoundPlaying?: any) {
        UIManager.getRef("musicRadioButtonOnPortrait") && (UIManager.getRef("musicRadioButtonOnPortrait").visible = !isSoundPlaying);
        UIManager.getRef("musicRadioButtonOffPortrait") && (UIManager.getRef("musicRadioButtonOffPortrait").visible = isSoundPlaying);
    }

    handleBgMusicRadioButtons(isSoundPlaying?: any) {
        if (!isSoundPlaying) {
            this.props.playBgSound(true);
            this.radioController("bgMusic_disablePortrait", "bgMusic_enablePortrait");

        } else {

            this.radioController("bgMusic_enablePortrait", "bgMusic_disablePortrait");

        }
    }
    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        //this.props.showSettingPanelForMobile
        //


        if (nextProps.showSettingPanelForMobile && nextProps.showSettingPanelForMobile !== this.props.showSettingPanelForMobile) {
            if (this.counter == 0) {
                this.counter++;
                return true;
            }
            else {


                let timer = TIMER.TimerManager.createTimer(50);
                timer.on('end', () => {
                    this.selectButtonAndContent();


                });
                timer.start();

                return false;
            }

        }

        if (nextProps.showSettingPanelForMobile && nextProps.layoutMode !== this.props.layoutMode) {
            this.setVisibilityAccordingToLayout(nextProps);
            this.selectButtonAndContent();
            return false;
        }
        else if (!nextProps.showSettingPanelForMobile && nextProps.showSettingPanelForMobile !== this.props.showSettingPanelForMobile) {
            UIManager.getRef("mainSettingPanelPortraitComponent").visible = false;
            this.props.setApplicationButtonpanelVisibility(true);

            return false;
        }
        if (nextProps.allSoundSFXStop !== this.props.allSoundSFXStop) {

            this.handleSoundRadioButtons(nextProps.allSoundSFXStop);
            if (nextProps.allSoundBGMStop) {
                nextProps.playingSound(false);
            }
            return false;
        }
        if (nextProps.allSoundBGMStop !== this.props.allSoundBGMStop) {

            this.handleBgMusicRadioButtons(nextProps.allSoundBGMStop);
            if (nextProps.allSoundSFXStop) {
                nextProps.playingSound(false);
            }
            return false;
        }
        return false;
    }



    render() {
        if (!this.props.showSettingPanelForMobile) {
            return (<></>)
        }
        let visibility;
        if (isMobile && window.innerWidth > window.innerHeight) {
            visibility = false;
        }
        else if (isMobile && window.innerWidth < window.innerHeight) {
            visibility = true;
        }

        return (<UIManager id={"mainSettingPanelPortraitComponent"} name={"mainSettingPanelPortraitComponent"} type={"Container"}
            ref={i => this.mainSettingPanelPortraitComponent = i} visible={visibility}
            x={0} y={0}>
            {
                this.displayUI && this.displayUI.map((i: any) =>
                    <UIManager key={`UIManager-${Math.random()}`} ClickHandler={this.handleEvent} langObj={this.props.langObj} type={i.type}
                        id={i.id} {...i} app={this.app} />)
            }
        </UIManager>)
    }
}


export default withPixiApp(connect(
    (state: Pick<IStore, 'desktopSettingPanelGameLevel' | 'wrapperState' | 'applicationState' | 'mainSettingPanelState' | 'soundState'>): IStateToProps =>
    ({
        showSettingPanelForMobile: state.mainSettingPanelState.showSettingPanelForMobile,
        openScreen: state.mainSettingPanelState.openScreen,
        layoutMode: state.applicationState.layoutMode,
        allSoundSFXStop: state.soundState.allSoundSFXStop,
        allSoundBGMStop: state.soundState.allSoundBGMStop,
        homeButton: state.wrapperState.homeButton,
        turboToggle: state.desktopSettingPanelGameLevel.turboToggle,
    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setAutoplayKeyboardListenerActive: (autoplayKeyboardListenerActive: boolean): any => dispatch(autoplayKeyboardListenerAction.setAutoplayKeyboardListenerActive(autoplayKeyboardListenerActive)),
        showSettingPanelContainerForMobile: (showSettingPanelForMobile: boolean, openScreen: any): any => dispatch(mainSettingPanelActions.showSettingPanelContainerForMobile(showSettingPanelForMobile, openScreen)),
        setApplicationButtonpanelVisibility: (visible: boolean): any => dispatch(aplicationActions.setApplicationButtonpanelVisibility(visible)),
        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutsActions.setApplicationLayoutObject(layoutobjectlist)),
        showBetHistory: (showHistory: any): any => dispatch(behaviourAction.showBetHistory(showHistory)),
        getApplicationHistoryResponse: (): any => dispatch(asyncActions.getApplicationHistoryResponse()),
        playingSound: (soundIsPlaying: any): any => dispatch(soundActions.playingSound(soundIsPlaying)),
        playBgSound: (bgSoundPlay: any): any => dispatch(gameLevelSoundActions.playBgSound(bgSoundPlay)),
        setReelGridTurboMode: (IsTurboMode: any): any => dispatch(reelGridActions.setTurboMode(IsTurboMode)),
        setGridTurboMode: (IsTurboMode: any): any => dispatch(gridsActions.setTurboMode(IsTurboMode)),

    }))(withMainSettingPanelPortraitComponentConfiguration(MainSettingPanelPortraitComponent)));